<div class="home-wrapper d-flex flex-column align-items-center">
  <div class="home-wrapper__box d-flex flex-column">
    <div class="d-flex justify-content-center">
      <img src="../../assets/img/logo-medispring-vertical.svg" width="150vw" height="150vh" />
    </div>
    <ms-login></ms-login>
  </div>
  <div class="text-highlight">{{ version }}</div>
</div>
